//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { searchWorkOrders } from '../../../../api/workOrder';

export default {
    name: 'page-detail-orders',
    props: {
        roomId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            columns: [
                {
                    type: 'index', width: 60,
                    align: 'center', fixed: 'left'
                },
                {
                    title: '工单类型',
                    width: 100,
                    align: 'center',
                    key: 'workOrderTypeStr',
                    fixed: 'left'
                },
                {
                    title: '工单单号', align: 'center', key: 'workOrderNo', width: 170, fixed: 'left',
                    render(h, params) {
                        let row = params.row;
                        let actions = [];
                        let code = row.workOrderNo;
                        if (code == null || code == '') {
                            code = '未填写';
                        }
                        actions.push(
                            h(
                                'a', {
                                    on: {
                                        click: function() {
                                            vm.showDetail(row);
                                        }
                                    }
                                },
                                code
                            )
                        );
                        return actions;
                    }
                },
                // {
                //     title: '城市名称', align: 'center', key: 'cityName', width: 150
                // },
                // {
                //     title: '项目名称', align: 'center', key: 'projectName', width: 150
                // },
                {
                    title: '客户名称', align: 'center', key: 'name', width: 150
                },
                {
                    title: '手机号码', align: 'center', key: 'mobile', width: 150
                },
                {
                    title: '来电时间', align: 'center', key: 'createTimeStr', width: 150
                },
                // {
                //     title: '报修类型', align: 'center', key: 'repairTypeStr', width: 150
                // },
                {
                    title: '工单来源', align: 'center', key: 'sourceStr', width: 150
                },
                {
                    title: '工单状态', align: 'center', key: 'statusStr', minWidth: 160
                },
                {
                    title: '开始处理时间', align: 'center', key: 'clStarTimeStr', width: 150
                },
                {
                    title: '完成处理时间', align: 'center', key: 'clEndTimeStr', width: 150
                }
                // {
                //     title: '工单超时状态', align: 'center', key: '', width: 150
                // },
                // {
                //     title: '派单超时状态', align: 'center', key: '', width: 150
                // },
                // {
                //     title: '是否回访', align: 'center', width: 150,
                //     render: (h, params) => {
                //         return h('span', params.row.isReturnVisit ? '是' : '否');
                //     }
                // },
                // {
                //     title: '转单状态', align: 'center', key: '', width: 150
                // }
                // {
                //     title: '回访坐席', align: 'center'
                // },
                // {
                //   title: '操作', align: 'center', slot: 'action', width: 150
                // }
            ],
            list: [],
            searchInput: {},
            pageSize: 20,
            currentPage: 1,
            totalCount: 0,
            loading: false
        };
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getWorkOrders();
        },
        pageSizeChange(pagesize) {
            this.pageSize = pagesize;
            this.getWorkOrders();
        },
        getWorkOrders() {
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.roomId = this.roomId;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            if (!this.searchInput.roomId) {
                this.list = [];
                this.totalCount = 0;
                return;
            }
            this.loading = true;
            searchWorkOrders(this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    created() {
        this.getWorkOrders();
    }
};
